export const GET_GEARBOX_PLANETARY_CHART = "GET_GEARBOX_PLANETARY_CHART";
export const GET_GEARBOX_PLANETARY_CHART_SUCCESS = "GET_GEARBOX_PLANETARY_CHART_SUCCESS";
export const GET_GEARBOX_PLANETARY_CHART_ERROR = "GET_GEARBOX_PLANETARY_CHART_ERROR";
export const SHOW_CONCERN_FREQUENCIES = "SHOW_CONCERN_FREQUENCIES";
export const HIDE_CONCERN_FREQUENCIES = "HIDE_CONCERN_FREQUENCIES";
